import InputField from "@medoma/components/InputField/InputField";
import { useLayoutEffect } from "react";
import {
  useFieldArray,
  useFormContext,
  type FieldValues,
} from "react-hook-form";
import Form from "@/components/Form/Form";
import { errorMessageAt } from "@/forms/fieldPath";
import { useFieldPathWithPrefix } from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/pages/template-manager/TemplateFieldValidationContext";
import type { TemplateTimeSlotsFields } from "@/pages/template-manager/TemplateForm/templateFormSchema";
import { useLingui } from "@lingui/react/macro";

export const TemplateTimeSlots = ({
  numberOfTimeslots,
  size = "default",
}: {
  numberOfTimeslots: number;
  size?: "default" | "compact";
}) => {
  const { t } = useLingui();
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const timeslotsFieldName =
    useFieldPathWithPrefix<TemplateTimeSlotsFields>("timeslots");
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  const { fields, append, remove } = useFieldArray({
    control,
    name: timeslotsFieldName,
  });

  useLayoutEffect(() => {
    if (numberOfTimeslots > fields.length) {
      append({ time: "" });
    }
    if (numberOfTimeslots < fields.length) {
      remove(fields.length - 1);
    }
  }, [append, fields.length, numberOfTimeslots, remove]);

  return (
    <Form.Row type="flex">
      {fields.map((field, index) => {
        const errorPath = `${timeslotsFieldName}.${index}.time`;

        return (
          <InputField
            key={field.id}
            label={t`Starttid`}
            showOptionalLabel={false}
            errorMessage={errorMessageAt(errors, errorPath)}
            type="time"
            size={size}
            {...register(errorPath, {
              required: isInFinalValidationPhase
                ? {
                    value: true,
                    message: t`Ange starttid`,
                  }
                : undefined,
              pattern: {
                value: /^\d{1,2}:\d{2}$/,
                message: t`Starttid anges på formatet HH:mm`,
              },
            })}
          />
        );
      })}
    </Form.Row>
  );
};
